<template>
  <div class="dept_box">
    <template v-if="loading">
      <a-spin />
    </template>
    <template v-else>
      <div class="box_ul" v-for="item in list" :key="item.id">
        <div class="flex">
          <div class="box_l no-wrap">{{ item.colloge }}</div>
          <div class="flex box_r">
            <div class="box_li no-wrap" v-for="subItem in item.children" :key="subItem.id" @click="gotoDetailedList(subItem)">
              {{ subItem.name }}
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import {findDepartmentListApi} from '../api/index'
export default {
  props: {naviArr:[]},
  data() {
    return {
      list:[
        // {colloge: '党政部门、群团组织',id:'1',data:[
        //   {value:'1-1', label:'教务处'},
        //   {value:'1-2', label:'学工处'},
        //   {value:'1-3', label:'党委宣传部'},
        //   {value:'1-4', label:'党委宣传部'},
        //   {value:'1-5', label:'党委宣传部'},
        //   {value:'1-6', label:'党委宣传部'},
        //   {value:'1-7', label:'党委宣传部'},
        //   {value:'1-8', label:'党委宣传部'},
        //   {value:'1-9', label:'党委宣传部'},
        // ]},
        // {colloge: '直属单位、附属单位',id:'2',data:[
        //   {value:'2-1', label:'图书馆'},
        //   {value:'2-2', label:'信息中心'},
        //   {value:'2-3', label:'编辑部'}
        // ]},
      ],
      loading: false,
    };
  },
  created() {
    console.log('this.naviArr',this.naviArr);
    
    this.loading = true;
    findDepartmentListApi().then(res => {
      // console.log(res,'部门------------');
      // 昆工大需求
      const list = Object.keys(res).map(key => ({ colloge: key, children: res[key] }));
      this.list = list;
      this.loading = false;
    })
  },
  mounted() {},
  methods: {
    gotoDetailedList(val){
      if(this.naviArr.length > 0){
        this.naviArr.forEach((item) => {
            if (item.link == "/detailedList") {
              this.$router.push("/detailedList?naviId=" + item.id + '&deptId=' + val.id + '&listServiceCount=' + val.listServiceCount);
            }
        });
        this.$emit('close', false)
      }
    },

  },
};
</script>

<style scoped lang="less">
.dept_box{
  padding: 40px 20px;
  background: #fff;
  z-index: 999;
  border: 1px solid #E0E5F0;  
  border-radius: 8px;
  max-width: 1200px;
  .box_ul{
    border-bottom: 1px solid #E0E5F0;
    margin-bottom: 37px;
    .flex{
      align-items: normal;
    }
  }
  .box_ul:last-child{
    margin-bottom: 0;
    border-bottom: none;
  }
  .box_l{
    font-size: 18px;
    flex: 1;
  }
  .box_r{
    flex-wrap: wrap;
    flex: 4;
    .box_li{
      margin-bottom: 40px;
      margin-right: 32px;
      font-size: 17px;
      color: #7f7f7f;
      cursor: pointer;
    }
    .box_li:hover{
      color: var(--themeColor);
    }
  }
  .no-wrap{
    display: flex;
    flex-wrap: nowrap;
  }
}
</style>
